import React, { Component } from 'react';
import './PersonRegist.css'
import Api from '../../api/wxapi';

import './config'
import intl from 'react-intl-universal';
import Select from 'react-select';
import api from '../../api/api';

import { inject ,observer} from 'mobx-react';

let Timer = null


@inject('store')
@observer
export default class Suggestion extends Component {
  constructor(props) {
    super();
    this.state = {
      storename: '',
      storeadress: '',
      deveiceId: '',
      username: '',
      mobile: '',
      mobilecode: '',
      sendTime: 0,
      depict: '',
      nativeuri: '',
      canCamera:false

    };
   

  }

  componentDidMount() {
    document.title = '意见反馈'
   
    let openid=sessionStorage.getItem('openid')
    if(openid&&openid.length>0){
      sessionStorage.setItem('openid',openid)
   
      this.wxconfig()
    }else {
      this.wxrz();
    }

  }
  render() {
    let {
      storename,
      username,
      mobile,
      depict,
      nativeuri

    } = this.state

    return (
      <div className='flex-column-container' style={{ paddingLeft: 12, paddingRight: 12, flex: 1, }}>

        <div className='itemContaier'>
          <p className='itemname'>{'门店名称'}</p>
          <input className="inputbox" type="text" value={storename} onChange={event => this.setState({ storename: event.target.value })} placeholder={'请输入所在门店名称'} />
        </div>


        <div className='itemContaiermiddle'>
          <p className='itemname'>{'意见反馈'}</p>
          <textarea className='inputboxmiddle' value={depict} onChange={event => this.setState({ depict: event.target.value })} placeholder={'请输入反馈内容'}></textarea>
          <div className='flex-row-container'>
            <img  onClick={this.camera}  style={{ width: 70, height: 70 }} src={require('../../assets/Camera.png')}></img>
            {this.state.nativeuri && ( <div>  <img style={{ width: 70, height: 70 }} src={nativeuri}></img> </div>)}
          </div>
        </div>

   
        <div className='itemContaier'>
          <p className='itemname'>{'请留下您的姓名与手机号码'}</p>
        <div className='flex-row-container'> 
          <input  style={{marginRight:10}} className="inputbox3" type="text" value={username} onChange={event => this.setState({ username: event.target.value })} placeholder={'姓名'} />
          <input className="inputbox7" type="text" value={mobile} onChange={event => this.setState({ mobile: event.target.value })} placeholder={'手机号码'} />
          </div> 
        </div>


        <button className="pr-button" onClick={this.submit}>{'提交'}</button>
      </div>
    )
  }

  camera =()=>{

    
    window.wx.chooseImage({
      count: 1, // 默认9
      sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success: (res)=> {
         this.localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
         
         var u = navigator.userAgent
         var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
         if(isAndroid){
          this.setState({nativeuri:this.localIds[0]})
         }else {
          window.wx.getLocalImgData({
            localId: this.localIds[0], // 图片的localID
            success:  (res)=> {
              var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
              this.setState({nativeuri:localData})
              console.log('-----nativeuri='+this.state.nativeuri)
            }
          });
         }
        
         console.log('id='+this.localIds[0]+'-----nativeuri='+this.state.nativeuri)
  
        window.wx.uploadImage({
          localId: this.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 1, // 默认为1，显示进度提示
          success: (res)=> {
            this.serverId = res.serverId; // 返回图片的服务器端ID
            console.log('url='+this.serverId)
          }
        });
      }
    });
    
 
  }


  submit = () => {
    let {
      storename,
     
      username,
      mobile,
      depict,
      nativeuri

    } = this.state

   

    if (storename && username && mobile && depict) {
      let params = {
        serverId:this.serverId,
        mobile: mobile,
        name: username,
        store: storename,
        advise: depict,
      }
      Api.postSuggestion(params).then(res => {
        console.log(res)
        if (res.data.code == 0) {
          this.props.history.push(`/person/ShowResult?flag=true&type=${global.constants.Suggestion}`)
        } 

      })

    } else {
      alert('请完善信息')
    }

  }




  wxconfig() {

    let appId = global.constants.wxappid;
    let appseb = global.constants.secret;
    let url =  window.location.href; 
   
    Api.getsha1code({ params: { url: url } }).then(res => {
      if (res.data.code == 0) {

          let data=res.data.data
          let nonceStr=data.nonceStr
          let signature=data.signature
          let time=data.timestamp
          window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId, // 必填，公众号的唯一标识
            timestamp: time, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature,// 必填，签名
            jsApiList: ['chooseImage','uploadImage','getLocalImgData','previewImage'] // 必填，需要使用的JS接口列表
          });
          window.wx.ready(function () {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          
          });

      }

    })

   
  }


  wxrz(){
   
    let code=this.getQueryString('code')
    let wxappid=global.constants.wxappid
    let secret=global.constants.secret

    let redirect_uri1=this.props.store.rootUrl+'person/Suggestion'
    let rurl=encodeURI(redirect_uri1)
    console.log(rurl)

   if(code){
      Api.getUserOpenid({ code:code})
      .then(res=>{
        console.log(res)
        if(res.data.code==0){
          let data=res.data.data
          sessionStorage.setItem('openid',data.openid)
          localStorage.setItem('openid',data.openid) 
          window.location.href=redirect_uri1
        }
       
      }) 
 
      
    }else {
      let wxrzurl=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxappid}&redirect_uri=${rurl}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
      window.location.href = wxrzurl;
    } 
       

  }

  isMobileNumber(phone) {
    let flag = false;
    let message = "";
    let myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;
    if (phone == '') {
      // console.log("手机号码不能为空");
      message = "手机号码不能为空！";
    } else if (phone.length != 11) {
      //console.log("请输入11位手机号码！");
      message = "请输入11位手机号码！";
    } else if (!myreg.test(phone)) {
      //console.log("请输入有效的手机号码！");
      message = "请输入有效的手机号码！";
    } else {
      flag = true;
    }
    if (message != "") {
      alert(message);
    }
    return flag;
  }

  getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]); return null;
  }


}



// WEBPACK FOOTER //
// ./src/views/person/Suggestion.js